;(function() {
  'use strict'

  angular.module('app.survey').component('surveyQuestionMood', {
    controller: Controller,
    templateUrl: 'survey-question-mood.html',
    bindings: {
      survey: '<',
      question: '<',
    },
  })

  /* @ngInject */
  function Controller() {
    var ctrl = this

    ctrl.$onInit = onInit
    ctrl.colorClass = colorClass
    ctrl.iconClass = iconClass

    function onInit() {
      ctrl.info = ctrl.question.MoodInfo
    }

    function colorClass(choice) {
      return _.find(ctrl.info, { value: choice.option }).colorClass
    }

    function iconClass(choice) {
      return _.find(ctrl.info, { value: choice.option }).iconClass
    }
  }
})()
